export const INIT_FORM = {
    id: "",
    campusId: 0,
    libraryId: 0,
    resourceTypeId: 0,
    name: "",
    brandId: 0,
    model: "",
    serial: "",
    barcode: "",
    details: "",
    active: true
};
export const OPTIONAL_FIELDS = ["details"];
export const INIT_ERRORS_FORM = {
    campusId: false,
    libraryId: false,
    resourceTypeId: false,
    brandId: false,
    model: false,
    serial: false,
    barcode: false
};
export const ERROR_TEXT_LIST = {
    CAMPUS_ID: "Campo vacío, debes seleccionar una opción.",
    LIBRARY_ID: "Campo vacío, debes seleccionar una opción.",
    BRAND_ID: "Es necesario agregar la marca",
    MODEL: "Es necesario agregar el modelo",
    SERIAL: "Es necesario agregar la serie",
    BARCODE: "Campo vacío, debes seleccionar una opción.",
};
export const STYLE_PROPS = {
    FOOTER_BUTTON: {
        size: "medium",
        width: "130px"
    }
};